export default __webpack_public_path__ + "assets/images/icon-check.a53da9639df1d954c88e4c139e2843c9.svg";